module.exports = __webpack_public_path__ + "static/media/hangman.13053ebb.png";